/*
**  esse script ajuda a simular o click em um produto a comprar na tela de compras
*/

const state = {
  simularClickProduto: false,
  fecharDialogSazonalidade: 0,
  produto_ultimo_click: {},
  count_ultimo_click: 0,
  count_abrir_detalhes_produto: 0,
  produto_selecionado_menu_contexto: {},
  item_clicado: ''
};

const getters = {
  getCountAbrirDetalhesProduto(state) {
    return state.count_abrir_detalhes_produto;
  },
  getProdutoUltimoClick(state) {
    return state.produto_ultimo_click;
  },
  getCountSimularUltimoClick(state) {
    return state.count_ultimo_click;
  },
  getSimularClickProduto(state) {
    return state.simularClickProduto;
  },
  getFecharDialogSazonalidade(state) {
    return state.fecharDialogSazonalidade;
  },
  GET_PRODUTO_SELECIONADO_MENU_CONTEXTO(state){
    return state.produto_selecionado_menu_contexto;
  },
  getProdutoClicado(state) {
    return state.item_clicado;
  }
};

const mutations = {
  setCountAbrirDetalhesProduto(state) {
    state.count_abrir_detalhes_produto++;
  },

  setProdutoUltimoClick(state, valor) {
    state.produto_ultimo_click = valor;
  },

  setCountSimularUltimoClick(state) {
    state.count_ultimo_click++;
  },

  setSimularClickProduto(state) {
    state.simularClickProduto = true;
  },

  resetSimularClickProduto(state) {
    state.simularClickProduto = false;
  },

  SET_FECHAR_DIALOG_SAZONALIDADE(state) {
    state.fecharDialogSazonalidade++;
  },

  SET_PRODUTO_SELECIONADO_MENU_CONTEXTO(state, valor){
    state.produto_selecionado_menu_contexto = valor;
  },

  setProdutoClicado(state, valor) {
    state.item_clicado = valor;
  },
};

const actions = {
  setCountAbrirDetalhesProduto({ commit }) {
    commit("setCountAbrirDetalhesProduto");
  },

  setProdutoUltimoClick({ commit }, valor) {
    commit("setProdutoUltimoClick", valor);
  },

  setCountSimularUltimoClick({ commit }) {
    commit("setCountSimularUltimoClick");
  },

  setSimularClickProduto: ({ commit }) => {
    commit("setSimularClickProduto", true);
  },

  resetSimularClickProduto: ({ commit }) => {
    commit("resetSimularClickProduto");
  },

  setProdutoClicado({ commit }, valor) {
    commit("setProdutoClicado", valor);
  },
};

export default { namespaced: true, state, mutations, getters, actions };
